export const invenType = [
  {
    key: 'SITE_SET_MOBILE_UNION',
    value: '优量汇'
  },
  {
    key: 'SITE_SET_KUAISHOU',
    value: '快手'
  },
  {
    key: 'SITE_SET_WECHAT',
    value: '微信公众号'
  },
  {
    key: 'SITE_SET_TENCENT_NEWS',
    value: '腾讯新闻'
  },
  {
    key: 'SITE_SET_TENCENT_VIDEO',
    value: '腾讯视频'
  },
  {
    key: 'SITE_SET_QQ_MUSIC_GAME',
    value: 'QQ、腾讯音乐及游戏'
  },
  {
    key: 'SITE_SET_MOMENTS',
    value: '微信朋友圈'
  },
  {
    key: 'SITE_SET_MINI_GAME_WECHAT',
    value: '微信小游戏'
  },
  {
    key: 'SITE_SET_MINI_GAME_QQ',
    value: 'QQ小游戏'
  },
  {
    key: 'SITE_SET_CHANNELS',
    value: '微信视频号'
  },
  {
    key: 'SITE_SET_WECHAT_PLUGIN',
    value: '微信新闻插件'
  },
  {
    key: 'SITE_SET_SEARCH_SCENE',
    value: '搜索场景'
  },
  {
    key: 'SITE_SET_PCQQ',
    value: '腾讯电脑端'
  },
  {
    key: 'AUTOMATIC_SITE_ENABLED',
    value: '自动版位'
  }
]

export const statusData = [
  {
    id: 0,
    name: '不限（包含已删除）'
  },
  {
    id: 1,
    name: '投放中'
  },
  {
    id: 2,
    name: '已删除'
  },
  {
    id: 3,
    name: '计划超出预算'
  },
  {
    id: 5,
    name: '未到达投放时间'
  },
  {
    id: 6,
    name: '已完成'
  },
  {
    id: 7,
    name: '不在投放时段'
  },
  {
    id: 8,
    name: '新建审核中'
  },
  {
    id: 9,
    name: '修改审核中'
  },
  {
    id: 10,
    name: '已终止'
  },
  {
    id: 11,
    name: '审核不通过'
  },
  {
    id: 12,
    name: '计划超出预算'
  },
  {
    id: 13,
    name: '账户余额不足'
  },
  {
    id: 15,
    name: '已暂停'
  },
  {
    id: 16,
    name: '已被项目暂停'
  },
  {
    id: 21,
    name: '已暂停（配额达限）'
  }
]

export const projectStatusData = [
  {
    id: 2,
    name: '不限（包含已删除）'
  },
  {
    id: 1,
    name: '启用'
  },
  {
    id: 0,
    name: '暂停'
  },
  {
    id: -1,
    name: '删除'
  },
  {
    id: 4,
    name: '计划超出预算'
  },
  {
    id: 6,
    name: '未达投放时间'
  },
  {
    id: 7,
    name: '已完成'
  },
  {
    id: 8,
    name: '不在投放时段'
  }
]
